<template>
    <v-flex xs12 mb-6>
        <v-text-field
            :value="value.name"
            :aria-label="formattedAriaLabel(
                metadata[`description${this.upperLocale}`],
                required
            )"
            :label="formattedLabel(
                metadata[`description${upperLocale}`],
                required
            )"
            :append-icon="appendIcon"
            :outlined="outlined"
            :name="metadata.name"
            :color="$vuetify.theme.primary"
            :background-color="$vuetify.theme.primary"
            :placeholder="placeholder"
            :rules="[getFileSizeCorrect, (!required || requiredField($t('appt.errors.' + metadata.name)))]"
            :messages="getMessage"
            readonly
            clearable
            validate-on-blur
            :data-meta-id="metadata.id"
            :id="metadata.name"
            @click:clear="deleteFile()"
            @click="hiddenClick()"
            @click:append="hiddenClick()"
            @focus="validateInputIsRequired"
        >
            <template v-slot-activator="{ on }">
                <v-tooltip top v-on="on">
                    <v-icon>icon_help</v-icon>
                    <span v-html="$t('appt.tooltips.scannedRequest')" />
                </v-tooltip>
            </template>
        </v-text-field>
        <input
            type="file"
            style="display: none"
            :accept="acceptedType"
            ref="documentInput"
            @change="onFilePicked($event)"
        />
    </v-flex>
</template>
<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { get } from 'lodash';
export default {
    name: 'trimoz-upload-file',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: [Object, String], required: false, default: () => { return {}; } },
        withIcon: { type: Boolean, required: false, default: false },
        acceptedType: { type: String, required: false, default: 'application/pdf, image/jpeg, image/png' },
        placeholder: { type: String, required: false, default: '' },
    },
    data() {
        return {
            doc: {
                name: null,
                url: null,
                file: null,
            },
            shouldValidateRequired: false,
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        appendIcon() {
            return this.withIcon ? 'fas fa-paperclip' : '';
        },
        getFileSizeCorrect() {
            return get(this.doc, 'file.size', 0) <= 8 * 1024 * 1024;
        },
        getMessage() {
            if (!this.getFileSizeCorrect) {
                return this.$i18n.t('base.errors.scannedRequestMaxSize');
            }
            if (this.shouldValidateRequired && !get(this.value, 'name')) {
                return this.$i18n.t('appt.errors.' + get(this.metadata, 'name'));
            }
            return this.$i18n.t('appt.scannedRequest');
        },
    },
    methods: {
        validateInputIsRequired() {
            if (this.required) {
                this.shouldValidateRequired = true;
            }
        },
        deleteFile() {
            this.doc = {
                name: null,
                url: null,
                file: null,
            };
            this.emitValue();
        },
        hiddenClick() {
            this.$refs['documentInput'].click();
        },
        onFilePicked(event) {
            const files = event.target.files;

            if (files[0] !== undefined) {
                this.doc.name = files[0].name;

                if (this.doc.name.lastIndexOf('.') <= 0) {
                    return;
                }

                const fReader = new FileReader();

                fReader.readAsDataURL(files[0]);
                fReader.addEventListener('load', () => {
                    this.doc.url = fReader.result;
                    this.doc.file = files[0]; // this is an image file that can be sent to server...
                    this.emitValue();
                });
            }
            else {
                this.doc = {};
            }
        },
        emitValue() {
            this.$emit('update:value', this.doc);
        },
    },
};
</script>
